<template>
  <div class="wxworkchatinspectioncontent" >
    <el-divider content-position="left">关键字列表</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.category_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入关键字"
        size="mini"
        clearable
        :remote-method="searchRemoteCfcategory"
        :loading="searchLoading"
        @change="handleSearchCfcategory"
      >
        <el-option
          v-for="searchCompany in searchCategories"
          :key="searchCompany.id"
          :label="searchCompany.content"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="mini" @click="categoryIn"
          >录入</el-button
        >
      </div>
    </div>
    <el-drawer
      :visible.sync="categoryIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <template slot="title">
        <span style="color: #409eff; font-size: 0.3rem; font-weight: bold"
          >录入</span
        >
      </template>
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="categoryForm"
          :rules="rules"
          ref="categoryForm"
          label-width="100px"
        >
          <el-form-item label="分类" prop="cate">
            <el-select
              v-model="categoryForm.cate"
              placeholder="请选择"
              clearable
              filterable
              size="mini"
              style="width: 100%"
              @click.native="loadCategory"
            >
              <el-option
                v-for="item in categoryIdOptions"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字" prop="content">
            <el-input
              v-model.trim="categoryForm.content"
              type="textarea"
              size="mini"
              placeholder=""
            ></el-input>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm('categoryForm')"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      :visible.sync="categoryEditDrawer"
      :direction="direction"
      :before-close="handleClose_edit"
      size="40%"
    >
      <template slot="title">
        <span style="color: #409eff; font-size: 0.3rem; font-weight: bold"
          >修改</span
        >
      </template>
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="editCategoryForm"
          :rules="rules"
          ref="editCategoryForm"
          label-width="100px"
        >
        <el-form-item label="分类" prop="cate">
            <el-select
              v-model="editCategoryForm.cate"
              placeholder="请选择"
              clearable
              filterable
              size="mini"
              style="width: 100%"
              @click.native="loadCategory"
            >
              <el-option
                v-for="item in categoryIdOptions"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字" prop="content">
            <el-input
              v-model.trim="editCategoryForm.content"
              type="textarea"
              size="mini"
            ></el-input>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('editCategoryForm')"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-table
      max-height="650"
      :data="categoryData"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="id" label="ID"> </el-table-column>
      <el-table-column prop="jianzhou_sms_cate.category_name" label="分类"> </el-table-column>
      <el-table-column prop="content" label="关键字"> </el-table-column>
      <el-table-column prop="sort" label="排序">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSort(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.$index, categoryData)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="categoryPerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WxWorkChatInspectionContent',
  data () {
    // var categoryId = (rule, value, callback) => {
    //   if (value.length > 100) {
    //     return callback(new Error('输入过长！'))
    //   }
    //   if (value.length === 0) {
    //     return callback(new Error('请输入分类名称！'))
    //   }
    //   callback()
    // }
    return {

      categoryIdOptions: '',
      searchArr: {
        category_id: ''
      },
      npage: 1,
      categoryPerPage: 10,
      total: null,
      listSortForm: [],
      categoryData: [],
      searcher: null,
      categoryEditDrawer: false,
      searchLoading: false,
      searchCategories: [],
      categoryIndrawer: false,
      direction: 'rtl',
      ifDisplay: false,
      ListIfDisplay: [],
      listSort: [],
      category: '',
      categoryForm: {
        content: '',
        sign: '',
        remark: '',
        send: false,
        cate: ''
      },
      editCategoryForm: {
        content: '',
        sign: '',
        remark: '',
        send: false,
        cate: ''
      },
      rules: {
        content: [
          { required: true, message: '请输入关键字', trigger: 'blur' },
          { max: 100, message: '最多100个字符', trigger: 'blur' }
        ],
        sign: [
          { required: true, message: '请输入签名', trigger: 'blur' },
          { max: 50, message: '最多50个字符', trigger: 'blur' }
        ],
        cate: [
          { required: true, message: '请选择分类', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.loadTable()
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  // watch: {
  //   searcher: function (n, o) {
  //     this.loadTable(n)
  //   }
  // },
  methods: {
    loadTable () {
      this.$axios
        .get('api/wwki/index', {
          params: {
            page: this.npage,
            perpage: this.categoryPerPage,
            searchItem: this.searcher
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryData = data.data.data
            this.total = data.data.total
            this.loadRadio()
            this.loadSort()
          }
        })
        .catch()
    },
    loadRadio () {
      this.categoryData.map(item => {
        if (item.send === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadSort () {
      this.categoryData.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.categoryPerPage = val
      this.loadTable()
    },
    editRow (index, data) {
      this.loadCategory()
      this.$axios
        .get('api/wwki/show', {
          params: {
            id: data[index].id
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            if (data.data.send === 1) {
              this.ifDisplay = false
            } else {
              this.ifDisplay = true
            }
            this.editCategoryForm.content = data.data.content
            this.editCategoryForm.sign = data.data.sign
            this.editCategoryForm.remark = data.data.remark
            this.editCategoryForm.cate = data.data.cate
            this.category = data.data.id
          }
        })
        .catch()
      this.categoryEditDrawer = true
    },
    searchRemoteCfcategory (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/wwki/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    handleSearchCfcategory (query) {
      this.npage = 1
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    categoryIn () {
      this.categoryIndrawer = true
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.$refs.categoryForm.resetFields()
          done()
        })
        .catch(_ => {})
    },
    handleClose_edit (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/wwki/store', {
              content: this.categoryForm.content,
              sign: this.categoryForm.sign,
              remark: this.categoryForm.remark,
              send: this.categoryForm.send === false ? 1 : 0,
              cate: this.categoryForm.cate
            })
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.categoryIndrawer = false
                this.resetForm('categoryForm')
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editSubmitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .put('api/wwki/edit', {
              id: this.category,
              content: this.editCategoryForm.content,
              sign: this.editCategoryForm.sign,
              remark: this.editCategoryForm.remark,
              send: this.ifDisplay === false ? 1 : 0,
              cate: this.editCategoryForm.cate
            })
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.categoryEditDrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editListRadio (row) {
      this.$axios
        .put('api/wwki/listshow', {
          id: row.id,
          send: this.ListIfDisplay[row.id] === false ? 1 : 0
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    setSort (row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .put('api/wwki/setsort', {
          id: row.id,
          sort: this.listSort[row.id]
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    loadCategory () {
      this.$axios.get('api/wwki/getcate').then(({data}) => {
        if (data.code === 1) {
          this.categoryIdOptions = data.data
        }
      }).catch()
    }
  }
}
</script>

<style  scoped>
.wxworkchatinspectioncontent {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/wx_work_chat_inspection/WxWorkChatInspectionContent.vue